import ToastEventBus from "primevue/toasteventbus";

// SEE:
// https://stackoverflow.com/questions/72425297/vue-warn-inject-can-only-be-used-inside-setup-or-functional-components
export const useToastService = () => {
    const showToast = (toastDetails) => {
        ToastEventBus.emit("add", toastDetails);
    };
    return { showToast };
};
